'use es6';

import get from 'transmute/get';
export const getIsPrivateLoad = data => get('privateLoad', data);